const inr = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });
const inrExact = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 2, maximumFractionDigits: 2 });
const price = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const rupees = (paise: number) => (paise % 100 === 0 ? inr.format(paise / 100) : inrExact.format(paise / 100));
export const px = (n: number) => price.format(n);

export function date(iso: string): string {
  return new Date(iso.length === 10 ? `${iso}T00:00:00+05:30` : iso).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
}

export function dateTime(iso: string): string {
  return new Date(iso).toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
    timeZone: "Asia/Kolkata",
  });
}

const PLAN_NAMES: Record<number, string> = { 30: "Monthly", 90: "Quarterly", 180: "Half-yearly", 365: "Yearly" };
/** "Quarterly · 90 days" */
export const planLength = (days: number) => (PLAN_NAMES[days] ? `${PLAN_NAMES[days]} · ${days} days` : `${days} days`);
